import React, { useContext } from 'react';
import c from 'classnames';
import { CommentPublisherResult } from '../../../CommentEditor/redux/types';
import CommentBox, { CommentBoxProps } from '../../../CommentBox/presets/CommentBox';
import { CommentContext } from '../../CommentContext';
import { useReplyCommentBoxBase } from './useReplyCommentBoxBase';

import s from './ReplyCommentBox.scss';

export interface Props extends Partial<
  Pick<CommentBoxProps, 'nc' | 'canPostComment' | 'className'>
> {
  onReplyPosted?: (result: CommentPublisherResult) => void;
}

/** Our `CommentBox` with some comment specific props passed through. */
const ReplyCommentBox: React.FC<Props> = ({ canPostComment, className, nc, onReplyPosted }) => {
  const { id, onCancel, onPublishSuccess } = useReplyCommentBoxBase({
    onPublishSuccess: onReplyPosted,
  });
  const { comment } = useContext(CommentContext);

  return (
    <CommentBox
      id={id}
      className={c(s['root'], className)}
      commentableType={comment.typeId}
      commentableItemId={comment.itemId}
      replyComment={comment}
      canPostComment={!!canPostComment}
      nc={nc}
      onPublishSuccess={onPublishSuccess}
      onClose={onCancel}
    />
  );
};
ReplyCommentBox.displayName = 'ReplyCommentBox';

export default ReplyCommentBox;
